/**
 * Aviso mostrado ao cancelar uma assistência que já tem trabalho feito na
 * fábrica (corte, bordo...). O backend recusa o cancelamento com a lista de
 * etapas; a pessoa confirma a perda e a tela reenvia com `confirmarPerda`.
 * Sem trabalho feito, o cancelamento já leva junto o ambiente de produção.
 */
import React from "react";

import { Checkbox, WarningBanner } from "./styles";

/** Etapas feitas vindas do erro do backend, ou null se o erro é outro. */
export function etapasDoErro(erro) {
  const p = erro?.payload;
  return p?.precisa_confirmar_perda ? (p.etapas || []) : null;
}

export default function AvisoPerdaProducao({ etapas, confirmado, onConfirmado }) {
  if (!etapas) return null;
  return (
    <WarningBanner style={{ display: "flex", flexDirection: "column", gap: 8 }}>
      <span>
        Já há trabalho feito na fábrica para esta solicitação:
        {" "}{etapas.map((e) => `${e.ambiente} (${e.etapa})`).join(", ")}.
        Cancelar cancela também o ambiente de produção e descarta esse trabalho.
      </span>
      <label style={{ display: "inline-flex", alignItems: "center", gap: 8, fontWeight: 600 }}>
        <Checkbox checked={confirmado} onChange={(e) => onConfirmado(e.target.checked)} />
        Confirmo a perda do que já foi feito
      </label>
    </WarningBanner>
  );
}
